import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import TimeWindowSectionTitle from "src/components/features/medium/AssetsFilter/components/TimeWindow/components/TimeWindowSectionTitle/TimeWindowSectionTitle";
import type { DateRangeValue } from "../../DateRangePicker.types";
import DateRangeCalendarDivider from "./components/DateRangeCalendarDivider/DateRangeCalendarDivider";
import DateRangeCalendarFooter from "./components/DateRangeCalendarFooter/DateRangeCalendarFooter";
import {
  MAX_DATE,
  MIN_DATE,
  STYLES,
  UNSELECTED_DAY_STYLES,
  VIEWS,
} from "./DateRangeCalendar.constants";
import { useDateRangeCalendar } from "./DateRangeCalendar.hooks";

interface DateRangeCalendarProps {
  value: DateRangeValue;
  onChange: (value: DateRangeValue) => void;
  onApply: () => void;
  withDivider?: boolean;
}

const DateRangeCalendar = ({
  value,
  onChange,
  onApply,
  withDivider = false,
}: DateRangeCalendarProps) => {
  const {
    onCalendarChange,
    onMonthChange,
    onYearChange,
    onLinkClick,
    viewedDates,
    isLinked,
    resetViewedDates,
  } = useDateRangeCalendar({ value, onChange, disableFuture: true });

  const isApplyDisabled = !value?.[0] || !value?.[1];
  const isResetDisabled = !viewedDates?.[0] || !viewedDates?.[1];

  return (
    <div className="flex items-stretch">
      <aside>
        <TimeWindowSectionTitle title="Start date" className="mt-2 -mb-5 ml-6" />
        <DateCalendar
          value={viewedDates[0]}
          disableFuture
          onChange={(v) => onCalendarChange(v, 0)}
          views={VIEWS}
          minDate={MIN_DATE}
          maxDate={MAX_DATE}
          onMonthChange={(date) => onMonthChange(date, 0)}
          onYearChange={(date) => onYearChange(date, 0)}
          sx={{
            ...STYLES,
            ...(value?.[0] ? {} : UNSELECTED_DAY_STYLES),
          }}
        />
      </aside>

      <DateRangeCalendarDivider {...{ isLinked, onLinkClick, withDivider }} />

      <aside>
        <TimeWindowSectionTitle title="End date" className="mt-2 -mb-5 ml-6" />
        <DateCalendar
          value={viewedDates[1]}
          disableFuture
          onChange={(v) => onCalendarChange(v, 1)}
          views={VIEWS}
          minDate={MIN_DATE}
          maxDate={MAX_DATE}
          onMonthChange={(date) => onMonthChange(date, 1)}
          onYearChange={(date) => onYearChange(date, 1)}
          sx={{
            ...STYLES,
            ...(value?.[1] ? {} : UNSELECTED_DAY_STYLES),
          }}
        />

        <DateRangeCalendarFooter
          disabled={isApplyDisabled}
          isResetDisabled={isResetDisabled}
          onApply={onApply}
          onReset={resetViewedDates}
        />
      </aside>
    </div>
  );
};

export default DateRangeCalendar;
